if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.addEventListener('click', (e) => {
          const nav = e.target.closest('.pp-modal-nav');
          if (!nav) return;
          e.preventDefault();
          e.stopPropagation();
          if (nav.classList.contains('pp-modal-nav--prev')) this._navigate(-1);
          else if (nav.classList.contains('pp-modal-nav--next')) this._navigate(1);
        });

        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft')  { e.preventDefault(); this._navigate(-1); }
          if (e.key === 'ArrowRight') { e.preventDefault(); this._navigate(1);  }
        });
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      // PAPAPATTES 11/09 : la classe utilisée ici (pp-active) doit rester
      // identique à celle attendue par assets/papapattes.css
      // (.product-media-modal .pp-modal-item.pp-active { display:block }),
      // qui gère déjà tout le style du carrousel (flèches, plein écran
      // mobile, safe-area). Ne PAS renommer sans mettre à jour ce fichier.
      showActiveMedia() {
        const mediaId = this.openedBy ? this.openedBy.getAttribute('data-media-id') : null;
        const items = this._getItems();
        if (!items.length) return;

        items.forEach((el) => el.classList.remove('pp-active'));

        let targetItem = null;
        if (mediaId) {
          targetItem = items.find((item) => item.querySelector('[data-media-id="' + mediaId + '"]'));
        }
        if (!targetItem) targetItem = items[0];

        targetItem.classList.add('pp-active');

        const dm = targetItem.querySelector('deferred-media');
        if (
          dm &&
          dm.querySelector('template') &&
          dm.querySelector('template').content.querySelector('.js-youtube')
        ) {
          dm.loadContent();
        }

        this._updateCounter();
      }

      _getItems() {
        return Array.from(this.querySelectorAll('.pp-modal-item'));
      }

      _navigate(direction) {
        const items = this._getItems();
        if (!items.length) return;

        const currentIndex = items.findIndex((el) => el.classList.contains('pp-active'));
        let nextIndex = currentIndex + direction;
        if (nextIndex < 0) nextIndex = items.length - 1;
        if (nextIndex >= items.length) nextIndex = 0;

        items.forEach((el) => el.classList.remove('pp-active'));
        items[nextIndex].classList.add('pp-active');

        this._updateCounter();
      }

      _updateCounter() {
        const counter = this.querySelector('.pp-modal-counter');
        if (!counter) return;
        const items = this._getItems();
        const idx = items.findIndex((el) => el.classList.contains('pp-active'));
        counter.textContent = (idx + 1) + ' / ' + items.length;
      }
    }
  );
}
